import type { FaireProductEntity } from "../../entity_types/product";

export const p_a27bsyqv9x: FaireProductEntity = {
  token: "p_a27bsyqv9x",
  type: "product",
  name: "Relaxing Herbal Tea, Organic, Kosher, Non ETO, Bulk, 1 lb",
  brandToken: "b_5ashuqcsm4",
  brandName: "Frontier Co-op",
  imageUrl:
    "https://cdn.faire.com/fastly/2296feb95579260e7d88a7e9fde058f646ac82b64ca29e92121641f856e6f99e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a8436241bf86e4b52da04ed2fc31f79f0db58cd508ff9681bf5377ef8e0a786d.jpeg",
    "https://cdn.faire.com/fastly/86dc976923a63349d18b7e3ddd531987488122835e9e9dd1c448f3f742b84e09.jpeg",
  ],
  priceDollars: 37.54,
  description:
    "Frontier Co-op® Organic Relaxing Herbal Tea is USDA certified organic, kosher  and non-irradiated. This soothing caffeine-free blend combines chamomile, peppermint, and red raspberry leaf to create a gentle, aromatic infusion. Ideal for evening menus, apothecary blends, and wellness assortments, it’s a trusted option for herbal tea programs. Popular with natural grocers, tea blenders, cafés, and bulk refill programs, this bulk format supports a cost-effective way to stock a high-demand herbal blend.\n\nAvailable in bulk bags to support low-waste merchandising and cost-effective stocking\nEvery purchase supports our Well Earth program for sustainable and ethical sourcing\nRigorously tested for purity and freshness to ensure clean, unadulterated teas and herbs\nMember-owned co-op putting people and planet before profits\n\nBring Frontier Co-op® teas to your assortment to offer products that are flavorful, responsibly sourced and grounded in quality and integrity.",
  tags: [],
  msrpDollars: 75.08,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:49.692Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
